import {
  PERFORMANCEPREDICATE_LOADING,
  GET_PERFORMANCEPREDICATE,
  GET_PERFORMANCEPREDICATE_SUCCESS,
  GET_PERFORMANCEPREDICATE_FAIL,
  ADD_PERFORMANCEPREDICATE_SUCCESS,
  ADD_PERFORMANCEPREDICATE_FAIL,
  DELETE_PERFORMANCEPREDICATE_SUCCESS,
  DELETE_PERFORMANCEPREDICATE_FAIL,
  UPDATE_PERFORMANCEPREDICATE_SUCCESS,
  UPDATE_PERFORMANCEPREDICATE_FAIL,
  PERFORMANCEPREDICATE_RESET
} from "./actionType";

const INIT_STATE = {
  performancePredicates: [],
  error: {},
};

const PerformancePredicate = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PERFORMANCEPREDICATE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PERFORMANCEPREDICATE:
          return {
            ...state,
            performancePredicates: action.payload.data,
            isPerformancePredicateCreated: false,
            isPerformancePredicateSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PERFORMANCEPREDICATE_FAIL:
      switch (action.payload.actionType) {
        case GET_PERFORMANCEPREDICATE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPerformancePredicateCreated: false,
            isPerformancePredicateSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PERFORMANCEPREDICATE: {
      return {
        ...state,
        isPerformancePredicateCreated: false,
        loading: true,
      };
    }

    case PERFORMANCEPREDICATE_LOADING: {
      return {
        ...state,
        isPerformancePredicateCreated: false,
        loading: true,
      };
    }

    case ADD_PERFORMANCEPREDICATE_SUCCESS:
      return {
        ...state,
        isPerformancePredicateCreated: true,
        loading: false,
        performancePredicates: [action.payload.data, ...state.performancePredicates],
      };

    case ADD_PERFORMANCEPREDICATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PERFORMANCEPREDICATE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformancePredicateCreated: true,
        performancePredicates: state.performancePredicates.filter(
          performancePredicate => performancePredicate.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PERFORMANCEPREDICATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PERFORMANCEPREDICATE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPerformancePredicateCreated: true,
        performancePredicates: state.performancePredicates.map(performancePredicate =>
          performancePredicate.id.toString() === action.payload.data.id.toString() ? { ...performancePredicate, ...action.payload.data } : performancePredicate
        ),
      };

    case UPDATE_PERFORMANCEPREDICATE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PERFORMANCEPREDICATE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PerformancePredicate;